import { Controller } from "stimulus";

import useEventController from "../composables/use_event_controller";

export default class extends Controller {
  static targets = ["onChange"];

  connect() {
    useEventController(this);

    const persisted = Object.hasOwn(this.element.dataset, "persisted");

    this.onChangeTargets.forEach((target) => {
      this.listenOn(target, "focus", this.addToForm.bind(this));
      this.listenOn(target, "input", this.addToForm.bind(this));
      this.listenOn(target, "change", this.addToForm.bind(this));
      this.removeFromForm(target, persisted);
    });
  }

  removeFromForm(target, persisted) {
    // Do not disable pre-populated fields from inquiries
    if (target.hasAttribute("name") && (persisted || !target.value)) {
      target.setAttribute("_name", target.getAttribute("name"));
      target.removeAttribute("name");
    }
  }

  addToForm() {
    this.onChangeTargets.forEach((target) => {
      if (target.hasAttribute("_name")) {
        target.setAttribute("name", target.getAttribute("_name"));
        target.removeAttribute("_name");
      }
    });
  }
}
